// extracted by mini-css-extract-plugin
export default {"workspaceContainer":"Root_workspaceContainer__AYw4x"};